import {useState} from 'react';
export default function useSessionStorage(key, initialValue = null) {
   //Manejo de errores
   const [err, seterr] = useState(null);
   const [storedValue, setStoredValue] = useState(() => {
      //Si no se esta ejecutando en el navegador
      if (typeof window === 'undefined') {
         return initialValue;
      }
      //Si se esta ejecuntado en un navegador
      try {
         // recuperamos data almacenada dentro de sessionStorage
         const item = window.sessionStorage.getItem(key);

         if (item) {
            // si existe parsear el valor almacenado
            return JSON.parse(item);
         } else {
            // caso contrario almacenar valor inicial en sessionStorage y retornar valor inicial
            window.sessionStorage.setItem(key, JSON.stringify(initialValue));
            return initialValue;
         }
      } catch (error) {
         // Si sucede error se retorna el valor inicial y se setea el error
         seterr(error);
         return initialValue;
      }
   });

   //Envoltorio del setter de estado para almacenamiento en local storage
   function setValue(value) {
      try {
         //permitir funcion como parametro para usar la misma API de useState
         const valueToStore = value instanceof Function ? value(storedValue) : value;
         // Almacenar el estado
         setStoredValue(valueToStore);
         // Almacenar en sessionStorage si nos encontramos en el navegador
         if (typeof window !== 'undefined') {
            window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
         }
         seterr(null);
      } catch (error) {
         seterr(error);
      }
   }
   function clearValue() {
      setStoredValue(null);
      if (typeof window !== 'undefined') {
         window.sessionStorage.removeItem(key);
      }
   }
   //Para mantener la misma firma de useState se retorna el arreglo con el estado y su setter aumentando un objeto con propiedades del storage error para que el usuario implemente su manejador
   return [storedValue, setValue, {error: err, clearValue}];
}
